import reducer from './reducers';

export { default as taskActions } from './actions';
export { default as taskSagas } from './sagas';

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/task/index.js